import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2138">
      <About data-id="element-2139" />
    </main>;
}